<template>
    <div class="song-add-page">
        <div class="page-header">
            <h1>添加新歌曲</h1>
            <p>将你喜爱的歌曲添加到歌单中</p>
        </div>

        <el-form ref="songFormRef" :model="songForm" :rules="rules" label-width="100px" class="song-form">
            <!-- 歌名输入 -->
            <el-form-item label="歌曲名称" prop="title">
                <el-input v-model="songForm.title" placeholder="请输入歌曲名称" clearable />
            </el-form-item>

            <!-- 分类选择 -->
            <el-form-item label="歌曲分类" prop="classId">
                <el-select v-model="songForm.classId" placeholder="请选择歌曲分类" :disabled="isLoading" filterable>
                    <el-option v-for="category in categories" :key="category.id" :label="category.name"
                        :value="category.class" />
                </el-select>
            </el-form-item>

            <!-- 付费状态选择 -->
            <el-form-item label="付费状态" prop="pay">
                <el-select v-model="songForm.pay" placeholder="请选择付费状态" :disabled="isLoading">
                    <el-option label="免费" value="免费" />
                    <el-option label="付费" value="付费" />
                    <el-option label="SC点歌" value="SC点歌" />
                </el-select>
            </el-form-item>

            <!-- 操作按钮 -->
            <el-form-item>
                <el-button type="primary" @click="submitForm">保存歌曲</el-button>
                <el-button @click="resetForm">取消</el-button>
            </el-form-item>
        </el-form>

        <!-- 加载状态 -->
        <div class="loading-overlay" v-if="isLoading">
            <el-skeleton animated />
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from 'axios';

// 表单引用
const songFormRef = ref(null);

// 表单数据
const songForm = reactive({
    title: '',
    classId: '',
    pay: '免费' // 默认为免费
});

// 表单验证规则
const rules = reactive({
    title: [
        { required: true, message: '请输入歌曲名称', trigger: 'blur' },
        { min: 1, max: 50, message: '歌曲名称长度不能超过50个字符', trigger: 'blur' }
    ],
    classId: [
        { required: true, message: '请选择歌曲分类', trigger: 'change' }
    ],
    pay: [
        { required: true, message: '请选择付费状态', trigger: 'change' }
    ]
});

// 状态管理
const categories = ref([]);  // 分类数据
const isLoading = ref(false); // 加载状态

// 生命周期钩子
onMounted(() => {
    fetchCategories(); // 加载分类数据
});

// 获取分类列表
const fetchCategories = async () => {
    isLoading.value = true;
    try {
        const response = await axios.get('/adminapi/class/list');
        categories.value = response.data.results || [];

    } catch (error) {
        console.error('获取分类列表失败:', error);
        ElMessage.error('网络错误，请检查网络连接');
    } finally {
        isLoading.value = false;
    }
};

// 提交表单
const submitForm = async () => {
    if (!songFormRef.value) return;

    // 表单验证
    const isValid = await new Promise(resolve => {
        songFormRef.value.validate(valid => resolve(valid));
    });

    if (!isValid) return;

    isLoading.value = true;
    try {
        // 发送添加歌曲请求
        const response3 = await axios.post('/adminapi/music/add', {
            title: songForm.title,
            classId: songForm.classId,
            pay: songForm.pay
        });
        ElMessage.success('歌曲添加成功');
        // 重置表单
        resetForm();
    } catch (error) {
        console.error('添加歌曲失败:', error);
        ElMessage.error('网络错误，请稍后重试');
    } finally {
        isLoading.value = false;
    }
};

// 重置表单
const resetForm = () => {
    songForm.title = '';
    songForm.classId = '';
    songForm.pay = '免费'; // 重置为默认值
    if (songFormRef.value) {
        songFormRef.value.resetFields();
    }
};
</script>

<style scoped lang="scss">
.song-add-page {
    padding: 30px;
    max-width: 500px;
    margin: 0 auto;

    .page-header {
        text-align: center;
        margin-bottom: 30px;

        h1 {
            font-size: 24px;
            font-weight: 600;
            color: #303133;
        }

        p {
            color: #909399;
            margin-top: 10px;
        }
    }

    .song-form {
        background-color: #fff;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .el-form-item {
            margin-bottom: 20px;
        }
    }

    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
}
</style>